import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constant } from 'src/app/shared/service/utils/contant';
import { ObjectifSpecifique } from 'src/app/shared/models/objectif_specifique';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';

@Component({
  selector: 'app-add-objectif-specifique',
  standalone: false,
  templateUrl: './add-objectif-specifique.component.html',
  styleUrl: './add-objectif-specifique.component.scss'
})



export class AddObjectifSpecifiqueComponent {


  constructor(
    private modalService: NgbModal,

    private paramService: ParameterService,
    private messageService: MessageService,
    private FecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,



  ) {

  }

  ngOnInit() {
    this.fetchDataPrograme()
  }

  close() {

    this.modalService.dismissAll();
  }

  item: ObjectifSpecifique = new ObjectifSpecifique();
  programmeData: any = []
  agenceData: any = [];
  resultatItems: any = [];
  addObejectif() {

    if (!this.item.canSave()) {
      this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: this.item.getErrorMessage() });

    } else {

      this.ngxService.start();

      this.item.programme_id = this.item.programme_id.id;
      this.paramService.addObjectif(this.item).subscribe(
        (response: any) => {
          ////console.log("la reponse du webservice",response);

          this.modalService.dismissAll();
          this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
          this.FecthDataService.notifySeriviceCreated();
          this.ngxService.stop();
        },
        (error: any) => {
          const apiError = error?.error;

          let errorMessage = apiError?.message || 'Une erreur est survenue';

          if (apiError?.errors) {
            errorMessage = Object.values(apiError.errors)
              .map((err: any) => err[0])
              .join(' | ');
          }

          this.messageService.add({
            severity: 'error',
            summary: Constant.suiviTitle,
            detail: errorMessage
          });
          this.FecthDataService.notifySeriviceCreated();
          this.ngxService.stop();


        }
      )
    }

  }

  fetchDataPrograme() {


    this.paramService.fetchDataPrograme().subscribe(

      (response: any) => {

        this.programmeData = response.data;

        ////console.log("this.programmeData",this.programmeData);
      //  this.getResultat();
      },
      (error) => {
        ////console.log("une erreur est survenu",error);

      }

    );
  }


  onSelectProgramme(){

    this.item.code = this.item.programme_id.code + '.'
  }
  getResultat() {
    this.paramService.getStatutRessource().subscribe(
      (response: any) => {
        //console.log("la réponse du webservice", response);
        this.resultatItems = response.data;
      },
      (error: any) => {
        //console.log("une erreur est survenu", error);

      }
    )
  }
}
